import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/visitador_medico/tipo_gasto';
import Tipo from './TipoGasto';


const ms2p = (state) => {
  return {
    ...state.vm_tipo_gasto,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Tipo);

